const initialState = {
  add: {
    isLoading: false,
    error: '',
  },
  update: {
    isLoading: false,
    error: '',
  },
};

export default initialState;
